import Inventory from '../../components/Inventory/Inventory';
import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';

export const InventoryRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.INVENTORY, role: Roles.VIEWER });

    return <LogicalRoute {...props} component={Inventory} disabled={disabled} />;
};
